import React from "react";
import { amountInWordsInr, formatInr } from "../../utils/financeFormat";

/** Table footer cell: visible amount + small in-words line (dark tables). */
export default function TableTotalAmount({ amount, toneClass = "text-warning" }) {
  const words = amountInWordsInr(amount);
  return (
    <>
      <div className={`fw-semibold ${toneClass}`.trim()}>{formatInr(amount)}</div>
      {words && words !== "Zero" ? <div className="analytics-table-total-words">{words}</div> : null}
    </>
  );
}

export const ANALYTICS_TABLE_TOTAL_ROW_CLASS = "analytics-table-total-row fw-semibold";
